import { axiosApiFreeClient } from '../../api';
import { store } from '../../store';
import { setAccessToken } from '../../store/slices/auth/slice';
import { LOGOUT } from '../constants';
import { destroySocket, reconnectSocket } from './socket.control';

export const bindSocketEvents = socket => {
  socket.on('connect', () => {
    console.log('✅ connected', socket.id);
  });

  socket.on('disconnect', reason => {
    console.log('❌ disconnected', reason);

    if (reason !== 'io client disconnect') {
      reconnectSocket();
    }
  });

  socket.on('error', async error => {
    const refreshToken = async () => {
      const refreshResponse = await axiosApiFreeClient.post('/d/refresh-token', {}, { withCredentials: true });
      const { accessToken } = refreshResponse.data.data;
      store.dispatch(setAccessToken({ accessToken }));
    };

    if (error.message === 'Not authenticated') {
      try {
        await refreshToken();
      } catch (error) {
        if (error.message === 'Network Error') {
          setTimeout(async () => {
            await refreshToken();
          }, 5000);
        } else {
          destroySocket();
          store.dispatch({ type: LOGOUT });
        }
      }
    }
  });

  socket.on('connect_error', error => {
    reconnectSocket(5000);
  });
};
